import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import isMobile from "ismobilejs";


export interface DeviceStateType {
    isMobile: boolean;
    isTouchEnabled: boolean;
    isEmbedded: boolean;
}

const detectIsMobile = (): boolean => {
    if (typeof window === 'undefined') return false;
    return isMobile(window.navigator).any;
};

const detectIsTouchEnabled = (): boolean => {
    if (typeof window === 'undefined') return false;
    return (
        'ontouchstart' in window ||
        (navigator as any).maxTouchPoints > 0 ||
        (navigator as any).msMaxTouchPoints > 0
    );
};

const detectIsEmbedded = (): boolean => {
    if (typeof window === 'undefined') return false;
    try {
        return window.localStorage.getItem('isEmbedded') === 'true';
    } catch {
        return false;
    }
};

export const deviceInitialState: DeviceStateType = {
    isMobile: detectIsMobile(),
    isTouchEnabled: detectIsTouchEnabled(),
    isEmbedded: detectIsEmbedded()
};

const deviceSlice = createSlice({
    name: 'device',
    initialState: deviceInitialState,
    reducers: {
        setIsMobile(state: DeviceStateType, action: PayloadAction<boolean>) {
            state.isMobile = action.payload;
        },
        setIsTouchEnabled(state: DeviceStateType, action: PayloadAction<boolean>) {
            state.isTouchEnabled = action.payload;
        },
        setIsEmbedded(state: DeviceStateType, action: PayloadAction<boolean>) {
            state.isEmbedded = action.payload;
            // persist change in localStorage for future reloads
            try {
                window.localStorage.setItem('isEmbedded', String(action.payload));
            } catch {
                /* ignore */
            }
        }
    }
});
 const { actions ,reducer } = deviceSlice;
export const { setIsMobile, setIsTouchEnabled, setIsEmbedded } = actions;

export default reducer;